import React from 'react';
import ReactDOM from 'react-dom/client';
import BioDigitalSankeyApp from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BioDigitalSankeyApp />
  </React.StrictMode>
);